import React, { Component } from 'react';
import http from '../modules/api';
import Button from '../modules/common/Button'; // 경로는 프로젝트에 맞게 조정
import {RpAutoConfigIntroBySalePrice} from './RpAutoConfigIntroBySalePrice';
import ProductPriceSelector from './ProductPriceSelector';
import {RpAutoAlgorithmTableBySalePrice} from './RpAutoAlgorithmTableBySalePrice';
import {RpCafe24ClonePopupByRpSelaPrice} from './RpCafe24ClonePopupByRpSelaPrice';
import WarningDialog from '../modules/dialogs/WarningDialog';

class ParentAutoRpSettingBySalePrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: "",
            temp_selected_price_cd : "",
            selected_price_cd : "",
        }
    }

    componentDidMount() {
        this.handleLoadSalePrice();
    }

  // 사용자의 할인율 저장 (POST)
  handleSaveSalePrice = () => {
    const { selected_price_cd } = this.state;

    http.post('/rest/shop/rp/user-product-price', {
        price_cd: selected_price_cd
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => {
      if (res.data.code === 200) {
        console.console('할인율 저장 성공');
      } 
    })
    .catch(err => {
      console.error('할인율 저장 에러:', err);
    });
  }

  // 사용자의 할인율 조회 (GET)
  handleLoadSalePrice = () => {
    http.get('/rest/shop/rp/user-product-price')
    .then(res => {
      if (res.data.code == 200) {
        this.setState({
            temp_selected_price_cd: res.data.price_cd || "",
            selected_price_cd: res.data.price_cd || "",
            selected_price_value: res.data.price_value || "",
            step: res.data.price_cd ? 2 : 0,
        });
      } else {
        this.setState({
            step: 0,
        });
      }
    })
    .catch(err => {
      console.error('할인율 조회 에러:', err);
      this.setState({
        step: 0,
    });
    });
  }

    onClickPriceSelectButton(selected_code_cd) {
        this.setState({
            temp_selected_price_cd: selected_code_cd,
        });
    }

    onClickNextButton(selected_code_cd, selected_code_value) {
        // console.log("selected_code_cd", selected_code_cd);
        if (selected_code_cd) {
            if (this.state.step == 1) {
                this.setState({
                    selected_price_cd: selected_code_cd,
                    selected_price_value: selected_code_value ? selected_code_value : this.state.selected_price_value,
                    step:2
                }, () => {
                    this.handleSaveSalePrice();
                });
            } 
        } else {
            this.setState({
                step: this.state.step + 1
            });
        }
    }

    onClickRegistButton(template_id, iframe_page_id, cafe24_category_display_group, targetCloneObj) {
        // console.log("template_id", template_id);
        this.setState({
            template_id: template_id,
            iframe_page_id: iframe_page_id,
            cafe24_category_display_group: cafe24_category_display_group,
            targetCloneObj: targetCloneObj,
            showClonePopup: true,
        }, () => {
            
        });
    }


    async onClickSettingButton(type) {
        if (type > 1) {
            await this.getSalePriceList();
        }
        await this.setState({
            step: type,
        });
    }

    async getSalePriceList() {
        try {
            const res = await http.get("/rest/shop/rp/productPrice/list?start_idx=0&row_cnt=1");
            if (res.data != null && res.data != '') {
                if (res.data.list && res.data.list.length > 0) {
                    let price_list = res.data.list;
                    this.setState({
                        temp_selected_price_cd: price_list[0].price_cd,
                        selected_price_cd: price_list[0].price_cd
                    });
                }
            }
        } catch (error) {
            // 에러 처리
        }
    }

  render() {
    let {step} = this.state;
    return (
        <div id='common-page-wrapper' className="style_guide_v2" style={{width: "100%", height: "100%", position: "absolute"}}>
            {
                step !== ""
                ? 
                    step == 0
                    ?   <RpAutoConfigIntroBySalePrice 
                            onClick={this.onClickNextButton.bind(this)}
                            onClickSettingButton={this.onClickSettingButton.bind(this)}
                        />
                    :   <>
                            <div className="auto-setting-header">
                                <div className="flexBox page-title">
                                    <h1 className="title">AI자동설정</h1>
                                    <span className="description">
                                        AI할인율를 선택하고 자동설정을 하시면 가격에 맞는 상품만 등록되고 진열순서를 고객활동 데이터에 맞춰서 자동진열되게 할 수 있습니다
                                    </span>
                                </div>
                                <div className="step-tracker">
                                    <span className={"step" + (this.state.step == 1 ? ' active' : '')} onClick={() => this.setState({step:1})}>
                                        상품가격 선택
                                        <span className="line"></span>    
                                    </span>
                                    <span className="arrow">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.2497 12.0003C17.247 12.1991 17.1701 12.3897 17.0341 12.5346L9.5341 20.0346C9.38838 20.1542 9.20338 20.2154 9.01509 20.2061C8.8268 20.1969 8.64869 20.1179 8.51539 19.9846C8.38208 19.8513 8.30313 19.6732 8.29388 19.4849C8.28464 19.2966 8.34576 19.1116 8.46535 18.9659L15.4404 12.0003L8.46535 5.03465C8.34576 4.88893 8.28464 4.70393 8.29389 4.51564C8.30313 4.32735 8.38209 4.14923 8.51539 4.01593C8.64869 3.88263 8.82681 3.80368 9.0151 3.79443C9.20339 3.78518 9.38838 3.8463 9.5341 3.9659L17.0341 11.4659C17.1701 11.6109 17.247 11.8015 17.2497 12.0003Z" fill="#808080" fill-opacity="0.55"/>
                                        </svg>
                                    </span>
                                    <span className={"step" + (this.state.step == 2 ? ' active' : '')} 
                                        onClick={() => {
                                            if (!this.state.temp_selected_price_cd) {
                                                this.setState({
                                                    show_warning_dialog: true,
                                                });
                                            } else {
                                                this.setState({
                                                    selected_price_cd: this.state.temp_selected_price_cd,
                                                    step:2
                                                }, () => {
                                                    this.handleSaveSalePrice();
                                                })
                                            }
                                        }}
                                    >
                                        자동진열종류
                                        <span className="line"></span>    
                                    </span>
                                </div>
                            </div>
                            <div className='ParentAutoRpSettingContents'>
                            {
                                step == 1
                                ? <ProductPriceSelector 
                                        onClickPriceSelectButton={this.onClickPriceSelectButton.bind(this)}
                                        onClickNextButton={this.onClickNextButton.bind(this)} 
                                        onPageChange={(pageNumber) => {this.setState({keywordActivePage: pageNumber})}}
                                        activePage={this.state.keywordActivePage}
                                        selected_price_cd = {this.state.selected_price_cd}
                                    />
                                :   step == 2
                                    ? <RpAutoAlgorithmTableBySalePrice 
                                        price_cd = {this.state.selected_price_cd}
                                        price_value = {this.state.selected_price_value}
                                        onClickRegistButton={this.onClickRegistButton.bind(this)}
                                    />
                                    : <div style={{width: "100%", height: "100%"}}></div>
                            }
                            </div>
                            {
                                this.state.show_warning_dialog
                                && <WarningDialog
                                    content={"항목을 선택해 주새요."}
                                    button_list={[{
                                        title : "확인",
                                        event_method : () => { this.setState({show_warning_dialog: false}) }
                                    }]}
                                />
                            }
                            {this.state.showClonePopup &&
                                <RpCafe24ClonePopupByRpSelaPrice
                                    org_event_setting_obj={this.state.targetCloneObj}
                                    onClose={() => this.setState({ showClonePopup: false, targetCloneObj: null })}
                                    iframe_page_id={this.state.iframe_page_id}
                                    cafe24_category_display_group={this.state.cafe24_category_display_group}
                                    selected_price_cd = {this.state.selected_price_cd}
                                    is_check_not_modify_5 = {true}
                                    is_check_not_modify_6 = {true}
                                />
                            }
                        </>
                :   <></>
            }
        </div>
    );
  }
}

export default ParentAutoRpSettingBySalePrice;